/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AgentCreate } from '../models';
// @ts-ignore
import type { AgentOut } from '../models';
// @ts-ignore
import type { AgentUpdate } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * AgentsApi - axios parameter creator
 * @export
 */
export const AgentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Clone an agent by its ID.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneAgent: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('cloneAgent', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/clone/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new agent for the user\'s organization.
         * @param {AgentCreate} agentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent: async (agentCreate: AgentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentCreate' is not null or undefined
            assertParamExists('createAgent', 'agentCreate', agentCreate)
            const localVarPath = `/api/v1/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an agent by its ID.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteAgent', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve detailed information about a specific agent by its ID.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgent', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a paginated list of agents belonging to the user\'s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a list of agents belonging to a specific organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsByOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAgentsByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/v1/agents/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the details of an existing agent.
         * @param {string} agentId 
         * @param {AgentUpdate} agentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent: async (agentId: string, agentUpdate: AgentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgent', 'agentId', agentId)
            // verify required parameter 'agentUpdate' is not null or undefined
            assertParamExists('updateAgent', 'agentUpdate', agentUpdate)
            const localVarPath = `/api/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentsApi - functional programming interface
 * @export
 */
export const AgentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Clone an agent by its ID.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloneAgent(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloneAgent(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.cloneAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new agent for the user\'s organization.
         * @param {AgentCreate} agentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgent(agentCreate: AgentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgent(agentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.createAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an agent by its ID.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgent(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgent(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.deleteAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve detailed information about a specific agent by its ID.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgent(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgent(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.getAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve a paginated list of agents belonging to the user\'s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.getAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve a list of agents belonging to a specific organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentsByOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentsByOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.getAgentsByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the details of an existing agent.
         * @param {string} agentId 
         * @param {AgentUpdate} agentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgent(agentId: string, agentUpdate: AgentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgent(agentId, agentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsApi.updateAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentsApi - factory interface
 * @export
 */
export const AgentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Clone an agent by its ID.
         * @param {AgentsApiCloneAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneAgent(requestParameters: AgentsApiCloneAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentOut> {
            return localVarFp.cloneAgent(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new agent for the user\'s organization.
         * @param {AgentsApiCreateAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent(requestParameters: AgentsApiCreateAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentOut> {
            return localVarFp.createAgent(requestParameters.agentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an agent by its ID.
         * @param {AgentsApiDeleteAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent(requestParameters: AgentsApiDeleteAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteAgent(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve detailed information about a specific agent by its ID.
         * @param {AgentsApiGetAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent(requestParameters: AgentsApiGetAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentOut> {
            return localVarFp.getAgent(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a paginated list of agents belonging to the user\'s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgents(options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentOut>> {
            return localVarFp.getAgents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a list of agents belonging to a specific organization.
         * @param {AgentsApiGetAgentsByOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsByOrganization(requestParameters: AgentsApiGetAgentsByOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentOut>> {
            return localVarFp.getAgentsByOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the details of an existing agent.
         * @param {AgentsApiUpdateAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent(requestParameters: AgentsApiUpdateAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentOut> {
            return localVarFp.updateAgent(requestParameters.agentId, requestParameters.agentUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cloneAgent operation in AgentsApi.
 * @export
 * @interface AgentsApiCloneAgentRequest
 */
export interface AgentsApiCloneAgentRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentsApiCloneAgent
     */
    readonly agentId: string
}

/**
 * Request parameters for createAgent operation in AgentsApi.
 * @export
 * @interface AgentsApiCreateAgentRequest
 */
export interface AgentsApiCreateAgentRequest {
    /**
     * 
     * @type {AgentCreate}
     * @memberof AgentsApiCreateAgent
     */
    readonly agentCreate: AgentCreate
}

/**
 * Request parameters for deleteAgent operation in AgentsApi.
 * @export
 * @interface AgentsApiDeleteAgentRequest
 */
export interface AgentsApiDeleteAgentRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentsApiDeleteAgent
     */
    readonly agentId: string
}

/**
 * Request parameters for getAgent operation in AgentsApi.
 * @export
 * @interface AgentsApiGetAgentRequest
 */
export interface AgentsApiGetAgentRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentsApiGetAgent
     */
    readonly agentId: string
}

/**
 * Request parameters for getAgentsByOrganization operation in AgentsApi.
 * @export
 * @interface AgentsApiGetAgentsByOrganizationRequest
 */
export interface AgentsApiGetAgentsByOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentsApiGetAgentsByOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for updateAgent operation in AgentsApi.
 * @export
 * @interface AgentsApiUpdateAgentRequest
 */
export interface AgentsApiUpdateAgentRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentsApiUpdateAgent
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentUpdate}
     * @memberof AgentsApiUpdateAgent
     */
    readonly agentUpdate: AgentUpdate
}

/**
 * AgentsApi - object-oriented interface
 * @export
 * @class AgentsApi
 * @extends {BaseAPI}
 */
export class AgentsApi extends BaseAPI {
    /**
     * 
     * @summary Clone an agent by its ID.
     * @param {AgentsApiCloneAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public cloneAgent(requestParameters: AgentsApiCloneAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).cloneAgent(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new agent for the user\'s organization.
     * @param {AgentsApiCreateAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public createAgent(requestParameters: AgentsApiCreateAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).createAgent(requestParameters.agentCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an agent by its ID.
     * @param {AgentsApiDeleteAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public deleteAgent(requestParameters: AgentsApiDeleteAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).deleteAgent(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve detailed information about a specific agent by its ID.
     * @param {AgentsApiGetAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public getAgent(requestParameters: AgentsApiGetAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).getAgent(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a paginated list of agents belonging to the user\'s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public getAgents(options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).getAgents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a list of agents belonging to a specific organization.
     * @param {AgentsApiGetAgentsByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public getAgentsByOrganization(requestParameters: AgentsApiGetAgentsByOrganizationRequest, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).getAgentsByOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the details of an existing agent.
     * @param {AgentsApiUpdateAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public updateAgent(requestParameters: AgentsApiUpdateAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentsApiFp(this.configuration).updateAgent(requestParameters.agentId, requestParameters.agentUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

